jQuery( document ).ready( function( $ ) {
  // Make mobile category selector go to tag page
  $( '.blog__tags select' ).on( 'change', function() {
    var tagUrl = $( this ).val();

    window.location = tagUrl;
  } )
});